const STORAGE_ERROR = "Storage is not available";
export class StorageBase {
    storage;
    constructor(storageType) {
        if (storageType) {
            this.storage = storageType;
        }
        else {
            throw new Error(STORAGE_ERROR);
        }
    }
    get(key) {
        return this.storage.getItem(key);
    }
    getStorage() {
        return this.storage;
    }
    remove(key) {
        this.storage.removeItem(key);
    }
    removeAll() {
        this.storage.clear();
    }
    set(key, value) {
        if (determineIfString(value)) {
            this.storage.setItem(key, value);
        }
        else {
            const serialized = JSON.stringify(value);
            this.storage.setItem(key, serialized);
        }
    }
}
function determineIfString(toBeDetermined) {
    if ((toBeDetermined instanceof String)) {
        return true;
    }
    return false;
}
